import React from "react";

import { SignatureSuccess as StyledSignatureSuccess } from "./SignatureSuccess.styles.js";
import { formatCpf, formatCnpj } from '../../utils/formatter';
import Icon from '../../components/Icon';

import Loading from "../../components/Loading";
import certifiedOn from "../../assets/images/Certified on.svg"

function SignatureSuccess ({ document, exportPdf, loading }) {
	if (!document || loading) {
		return <Loading />
	}

	return (
		<StyledSignatureSuccess className="doca">
			<StyledSignatureSuccess.Container className="doca-flex doca-flex-col doca-flex-1">
				<div className="doca-mb-4 doca-w-full">
					<StyledSignatureSuccess.HeaderTitle>
						Assinatura
					</StyledSignatureSuccess.HeaderTitle>
					<StyledSignatureSuccess.HeaderSubtitle>
						{document?.company?.name} enviou o seguinte documento para você assinar:
					</StyledSignatureSuccess.HeaderSubtitle>
				</div>

				<div className="doca-flex doca-justify-center">
					<StyledSignatureSuccess.ImageSuccess className="doca-mb-2" src={certifiedOn} />
				</div>

				<div className="doca-flex doca-justify-center">
					<div className="doca-flex doca-flex-col doca-items-center doca-mb-8">
						<StyledSignatureSuccess.Title>
							O documento foi assinado com sucesso!
						</StyledSignatureSuccess.Title>
						<StyledSignatureSuccess.Text>
							Enviamos sua resposta para {document?.company?.name}.
						</StyledSignatureSuccess.Text>
					</div>
				</div>

				<div className="doca-flex doca-flex-col doca-flex-1 doca-justify-end">
					<StyledSignatureSuccess.SignatureContainer className="doca-flex doca-flex-col doca-justify-center doca-items-center doca-items-center doca-w-full doca-mb-4 doca-p-3">
						<StyledSignatureSuccess.SignatureBox src={document.signature_url} />
					</StyledSignatureSuccess.SignatureContainer>

					<StyledSignatureSuccess.UserContainer>
						<StyledSignatureSuccess.UserName>
							{document?.destinatary?.name}
						</StyledSignatureSuccess.UserName>
						<StyledSignatureSuccess.Cpf>
							{document?.destinatary?.cpf
								? formatCpf(document?.destinatary?.cpf)
								: formatCnpj(document?.destinatary?.cnpj)}
						</StyledSignatureSuccess.Cpf>
					</StyledSignatureSuccess.UserContainer>

					<div className="doca-flex doca-justify-center">
						<StyledSignatureSuccess.Button disabled={loading} onClick={exportPdf}>
							<Icon name='download-button' marginRight={8} />
							<StyledSignatureSuccess.ButtonText>
								Baixar documento
							</StyledSignatureSuccess.ButtonText>
						</StyledSignatureSuccess.Button>
					</div>
				</div>
			</StyledSignatureSuccess.Container>
		</StyledSignatureSuccess>
	)
}

export default SignatureSuccess;
